import { combineReducers, Reducer } from 'redux';

import * as types from './tasks-simple.types';
import * as constants from './tasks-simple.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.ITasksSimplePageState = {
  myTasks: { active: [], done: [] },
  qi: { active: [], done: [] },
  watcher: '',
  isFetched: false,
  lastCreatedTaskId: null,
};

const myTasksReducer: Reducer<
  types.ITasksSimplePageState['myTasks'],
  types.IStoreTaskSimple | types.IClearTaskSimple
> = (state = initialState.myTasks, action) => {
  if (isActionOfType<types.IStoreTaskSimple>(action, constants.STORE_TASK_SIMPLE)) {
    return action.payload;
  } else if (isActionOfType<types.IClearTaskSimple>(action, constants.CLEAR_TASK_SIMPLE)) {
    return initialState.myTasks;
  }

  return state;
};

const qiReducer: Reducer<types.ITasksSimplePageState['qi'], types.IStoreTaskSimple | types.IClearTaskSimple> = (
  state = initialState.qi,
  action,
) => {
  if (isActionOfType<types.IStoreTaskSimple>(action, constants.STORE_QI)) {
    return action.payload;
  } else if (isActionOfType<types.IClearTaskSimple>(action, constants.CLEAR_QI)) {
    return initialState.qi;
  }

  return state;
};
const isFetchedReducer: Reducer<
  types.ITasksSimplePageState['isFetched'],
  types.IStoreIsFetched | types.IClearIsFetched
> = (state = initialState.isFetched, action) => {
  if (isActionOfType<types.IStoreIsFetched>(action, constants.STORE_IS_FETCHED)) {
    return true;
  } else if (isActionOfType<types.IClearIsFetched>(action, constants.CLEAR_IS_FETCHED)) {
    return initialState.isFetched;
  }
  return state;
};

const watcherReducer: Reducer<types.ITasksSimplePageState['watcher'], types.IStoreWatcher | types.IClearWatcher> = (
  state = initialState.watcher,
  action,
) => {
  if (isActionOfType<types.IStoreWatcher>(action, constants.STORE_WATCHER)) {
    return action.payload;
  } else if (isActionOfType<types.IClearWatcher>(action, constants.CLEAR_WATCHER)) {
    return initialState.watcher;
  }
  return state;
};

const lastCreatedTaskIdReducer: Reducer<
  types.ITasksSimplePageState['lastCreatedTaskId'],
  types.IStoreCreatedTaskId | types.IClearCreatedTaskId
> = (state = initialState.lastCreatedTaskId, action) => {
  if (isActionOfType<types.IStoreCreatedTaskId>(action, constants.STORE_CREATED_TASK_ID)) {
    return action.payload;
  } else if (isActionOfType<types.IClearCreatedTaskId>(action, constants.CLEAR_CREATED_TASK_ID)) {
    return null;
  }
  return state;
};

export const tasksSimplePageReducer: Reducer<
  types.ITasksSimplePageState,
  types.ITasksSimplePageAction
> = combineReducers({
  myTasks: myTasksReducer,
  qi: qiReducer,
  watcher: watcherReducer,
  isFetched: isFetchedReducer,
  lastCreatedTaskId: lastCreatedTaskIdReducer,
});
